export function removeClassBySelector(selector, targetClass) {
    document.querySelectorAll(selector).forEach( (item) => item.classList.remove(targetClass))
}
